module.exports = __webpack_public_path__ + "static/media/doc-1.06e48f87.jpg";